import { errors } from "./errors";
import { companies } from "./companies";
import { staff } from "./staff";
import { shops } from "./shops";
import { users } from "./users";
import { notices } from "./notices";
import { transactions } from "./transactions";
import { contacts } from "./contacts";
import { profits } from "./profits";
import { partners } from "./partners";

export const jp = {
  login:  'ログイン',
  mail_address: 'メールアドレス',
  code: 'コード',
  login_id:  'ログインID',
  password: 'パスワード',
  password_confirm: 'パスワード（再確認）',
  current_password: '現在のパスワード',
  new_password: '新しいパスワード',
  btn_send_mail: '送信する',
  btn_back_login: 'ログイン画面ヘ',
  btn_reset_password: 'パスワードを再設定する',
  btn_set_password: 'パスワードを設定する',
  show_password: 'パスワードを表示する',
  is_forgot_password: 'パスワードを忘れた方は',
  is_forgot_login_id: 'ログインIDを忘れた方は',
  login_line_title: 'LINEでログインする',
  is_here: 'こちら',
  format_password: '半角英数字記号8文字以上',
  send_mail_completed: 'メール通知が完了しました',
  errors: errors,
  noti_from_admin: '運営からのお知らせ',
  show_all_noti: '過去のお知らせはこちら',
  reset_account_completed: '「{0}」へログイン情報の通知メールを再送しました。',
  memo: 'メモ',
  items: {
    in: '件中',
    is_showing: '件目',
    showing: '表示中',
  },
  quantity_item_is_showing_table_header: '{0}-{1}件を表示中（全{2}件）',
  quantity_item_is_showing_table_footer: '{0}件中 {1}-{2}件目 表示中',
  prev: '＜ 前へ',
  next: '次へ ＞',
  btn_search: '検索',
  btn_clear: 'クリア',
  btn_create: '新規登録',
  companies: companies,
  table: {
    no_data: '該当のデータがありません。'
  },
  required: '※必須',
  status: {
    active: '有効',
    inactive: '無効',
    pending: '承認待ち'
  },
  create: '登録',
  back: '戻る',
  shops: shops,
  update: '編集',
  staff: staff,
  gender: {
    male: '男性',
    famale: '女性',
    no_select: '選択なし'
  },
  no_file_choose: '選択されていません',
  bank_account_type_saving: '普通預金',
  bank_account_type_checking: '当座預金',
  reset_account_info: 'ログイン情報を再通知する',
  reset_account_form: {
    title: 'ログイン情報を再通知しますか？',
    mail_address: '通知先メールアドレス',
    send: '通知する',
    back: '通知せず戻る',
  },
  time_point: '時点',
  earn_kokoro: '獲得ココロン',
  no_data: 'データなし',
  users: users,
  notices: notices,
  transactions: transactions,
  contacts: contacts,
  kokoron: 'ココロン',
  kokoroduke_admin: 'ココロヅケ 運営チーム',
  profits: profits,
  all: 'すべて',
  year: '年',
  change_password: {
    group_current_input: '現在のパスワードを入力してください',
    group_change_password: '新しいパスワードを入力し、パスワードを再設定してください',
    group_first_login_input: 'パスワードを入力し、パスワードを設定してください',
    check_password: '※パスワードは半角英数字、記号の全てを1文字以上使用してください \n（設定例）#5s4kd8h、k7!8d5oaなど',
    placeholder: {
      current_password: '現在のパスワード',
      new_password: '新しいパスワード',
      confirm_password: '新しいパスワード（再確認）',
    },
    label: {
      current_password: '現在のパスワード（半角英数字記号8文字以上）',
      new_password: 'パスワード（半角英数字記号8文字以上）'
    }
  },
  change_mail: {
    send: {
      group_current_input: 'メールアドレスの登録・変更には認証が必要です。',
      desc: '新しいメールアドレスをご入力ください。\nご入力いただいたメールアドレス宛に認証コードをお送りします。',
      placeholder: '新しいメールアドレス',
      btn: '認証コード送信',
    },
    verify: {
      group_current_input: '受信メールをご確認の上、認証コードを入力してください。',
      placeholder: '認証コード',
      btn: '認証へ',
      btn_resend: 'コードを再送する',
    },
    done: {
      group_current_input: 'メールアドレスの登録・変更が完了しました！',
      btn: 'メンバー詳細へ',
    },
    popup: {
      title: 'お問い合わせにはメール認証が必須です',
      desc: '本人確認のため、メールアドレスの認証をお願いします。 \n認証が完了すると、お問い合わせをご利用いただけます。',
      btn_redirect: '入力画面へ',
      btn_back: '戻る',
    },
  },
  point_in_current_month: '今月の獲得ココロン',
  partners: partners,
}
